import { isMobile } from '@components/Utility/index.js';
export const Environment = {
    appName: '',
    apiRoot: window.location.protocol + '//' + window.location.host + '/api/',
    autoLoadCaptions: false,
    baseUrl: window.location.origin,
    clientVersion: '' // gets set in common.php for now.
    ,
    hotfixVersion: '0',
    configData: {},
    dateStorageFormat: 'yyyy-MM-dd',
    timeStorageFormat: 'HH:mm:ss.SSS',
    datetimeStorageFormat: 'yyyy-MM-dd HH:mm:ss.SSS',
    datetimeFormat: 'yyyy-MM-dd HH:mm' // this format is overriden on application startup in Application.ts
    ,
    dateFormat: 'yyyy-MM-dd' // set in Application.ts by parsing datetimeFormat
    ,
    timeFormat: 'HH:mm' // set in Application.ts by parsing datetimeFormat
    ,
    dbVersion: '' // gets set on app startup when loading app config
    ,
    devMode: false,
    disableCache: false,
    downloadRoot: window.location.protocol + '//' + window.location.host + '/download/',
    dynamicRoutes: false,
    language: 'ENGLISH',
    locale: 'en-US',
    mobile: false,
    numberDecimal: '.',
    numberThousandSeparator: ',',
    oAuthConfig: [] // example: [{"oauth_q360logincaption":"Solutions360.com","webmailconfigno":"UQ99388024","oauth_provider":"AZURE"},{"oauth_q360logincaption":"S360 Gmail","webmailconfigno":"UQ99512924","oauth_provider":"GOOGLE"}]
    ,
    permLevel: 0,
    perms: {},
    screenMode: 'single',
    screenModeMobile: 'single',
    sizing: '',
    contrast: '',
    gridSizing: '',
    theme: '',
    timezoneMapping: {},
    tokens: {},
    uploadRoot: window.location.protocol + '//' + window.location.host + '/upload/',
    userHomepage: '',
    userMobileHomepage: '',
    userId: '',
    userType: '' // unknown until the application loads
    ,
    viewMode: 'full',
    gridAlternateColors: false,
    gridVerticalLines: false,
    gridHighlightToMultiSelect: true,
    gridCellOverflowDelay: 800,
    gridShowTimezoneSelect: true,
    askqEnabled: false,
    enableHelpArticles: true,
    enableAIArticles: true,
    enableWebmailCalendar: 'N' //stored on userid table for now so it's a Y/N instead of true/false
    ,
    editorPaste: 'no-styles' // 'plain'|'no-styles'|'full'
    ,
    editorShiftPaste: 'full',
    accordionToolbar: true,
    loginOverlay: false,
    mapProvider: 'google',
    userEmail: ''
};
/**
 * For setting up application environment settings
 * @param variable
 * @param value
 * @constructor
 */
export function ENV(variable, value) {
    if (typeof value === 'undefined') {
        return Environment[variable];
    }
    // @ts-ignore
    Environment[variable] = value;
}
export function screenMode() {
    if (isMobile()) {
        return ENV('screenModeMobile');
    }
    else {
        return ENV('screenMode');
    }
}
export function TOKEN(tokenFormat, value) {
    if (typeof value === 'undefined') {
        return Environment.tokens[tokenFormat];
    }
    Environment.tokens[tokenFormat] = value;
}
/**
 * Sets or retrieves a configuration value from the environment's configuration data
 *
 * @param {string} configItem - The name of the configuration item to set or retrieve
 * @param {string|number} [configValue] - The value to set for the configuration item (optional)
 * @param {string} [configValue2] - Another value to set for the configuration item (optional)
 * @returns {string|undefined|{configValue1: string, configValue2: string}} - The retrieved configuration value or undefined if not found,
 *                                                                        or an object containing the set of configuration values
 */
export function CONFIG(configItem, configValue, configValue2) {
    if (typeof configValue === 'undefined') {
        // CONFIG('SOMECONFIG') -- they requested a whole config object
        return Environment.configData[configItem] || {};
    }
    else if (typeof configValue === 'number') {
        // CONFIG('SOMECONFIG', 1) -- they requested a specific configvalue
        return (Environment.configData[configItem] || {})[`configValue${configValue}`] || '';
    }
    // CONFIG('SOMECONFIG', 'value1' ,'value2') -- they requested to set the config values 
    Environment.configData[configItem] = {
        configValue1: configValue,
        configValue2
    };
}
export function PERM(permName, value) {
    permName = permName.toLowerCase();
    if (typeof value === 'undefined') {
        // PERM('someperm_view') -- they requested to see what the permission value is
        return Environment.perms[permName] || '';
    }
    // PERM('someperm_view', 'Y') -- they requested to set the permission values 
    Environment.perms[permName] = value;
}
export function isCalendarIntegrationEnabled() {
    return CONFIG('EXCHANGE_INTEGRATION', 1) == '1';
}
export function isCalendarEnabled() {
    return isCalendarIntegrationEnabled() && ENV('enableWebmailCalendar') === 'Y';
}
/**
 * https://moment.github.io/luxon/#/formatting?id=table-of-tokens
 *
 * most of the formatting tokens match t-sql ie. select format(getDate(), 'yyyy-MM-dd HH:mm:ss.fff') is the same format as luxon EXCEPT .fff in SQL would be .SSS in luxon..
 *
 */ 
